const indexItems = [
  { title: '韩漫精选', desc: '恋爱 · 职场 · 浪漫', icon: 'ri-heart-line', color: 'bg-primary-100 text-primary-600' },
  { title: '国漫专区', desc: '修仙 · 都市 · 热血', icon: 'ri-sword-line', color: 'bg-accent-100 text-accent-600' },
  { title: '日漫经典', desc: '少年 · 冒险 · 战斗', icon: 'ri-rocket-line', color: 'bg-secondary-100 text-secondary-600' },
  { title: '恋爱漫画', desc: '甜蜜 · 心动 · 治愈', icon: 'ri-heart-pulse-line', color: 'bg-primary-100 text-primary-600' },
  { title: '热血漫画', desc: '战斗 · 成长 · 高燃', icon: 'ri-flashlight-line', color: 'bg-accent-100 text-accent-600' },
  { title: '悬疑漫画', desc: '推理 · 反转 · 烧脑', icon: 'ri-search-eye-line', color: 'bg-secondary-100 text-secondary-600' },
  { title: '奇幻漫画', desc: '异世界 · 魔法 · 冒险', icon: 'ri-magic-line', color: 'bg-primary-100 text-primary-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">漫题索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类型快速找到你想看的漫画，韩漫日漫国漫全部分类一目了然
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className={`group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all ${
                idx === 0 ? 'sm:col-span-2 row-span-2 flex flex-col justify-center' : ''
              }`}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.color} mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-950 mb-1">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}